module.exports = __webpack_public_path__ + "static/media/5.83bd4da2.jpg";